export const MAPBOX_TOKEN =
  "pk.eyJ1IjoicGF0OTAwMCIsImEiOiJjbDNhaXRnbzEwMXk1M2Vwa3F0MHFrNHFkIn0.1Y9DYByZSC-BkeaKFHpMZw";

export const MAP_KEY = "AIzaSyA-j0i2vMQUKpmYph5mUn1C85UkCT6VRvg";

export const mapOptions = {
  zoom: 12,
  center: {
    lat: 19.3887859,
    lng: -99.06231179999999,
  },
  mapTypeControl: true,
  streetViewControl: true,
  fullscreenControl: true,
  zoomControl: true,
  gestureHandling: 'cooperative',
};

export const PAGINA_DETALLE = {
  proveedor: "proveedor",
  mapa: "mapa",
  archivos: "archivos",
  hisotrial: "historial",
  chat: "chat",
  llamadas: "llamadas",
  fotos: "fotos",
  sms: "sms",
  edega: "edega",
  // placas: "placas",
};

/// estatus del servicio vivo
export const ESTATUS = {
  iniciado: 1,
  asignado: 2,
  arribo: 3,
  concluido: 4,
};

/// estatus del servicvio en lo general
export const ESTATUS_FINAL = {
  abierto: 1,
  concluido: 2,
  otorgado: 3,
  canceladoConCosto: 4,
  canceladoSinCosto: 5,
};

export const mesesOptions = [
  { texto: "Ene", valor: 1 },
  { texto: "Feb", valor: 2 },
  { texto: "Mar", valor: 3 },
  { texto: "Abr", valor: 4 },
  { texto: "May", valor: 5 },
  { texto: "Jun", valor: 6 },
  { texto: "Jul", valor: 7 },
  { texto: "Ago", valor: 8 },
  { texto: "Sep", valor: 9 },
  { texto: "Oct", valor: 10 },
  { texto: "Nov", valor: 11 },
  { texto: "Dic", valor: 12 },
];

export const CLIENTES_IDS = {
  CHUBB: "E7xoV9XAlN",
  EL_AGUILA: "ve7SE85lpL",
  EL_AGUILADev: "pgqSExjHvc",

  HDI: "D2pceuqnx8",
  gnp: "Eprtn7jQhx",
  QUALITAS: "vwFMCVA2IX",
  GS: "QXue1U4LAL",
  EDEGA: "cuWlM7SFk7",
  EDEGA_PROD: "Gow2SBEh1U",
  EDEGA_QA: "dMaSJXbJjR",

  QUALITAS_EP_CAMPANIAID: 60,
  QUALITAS_EP_CAMPANIAID_DEV: 58,
  GS_PROD: 61,
  GS_DEV: 59,
};

export const cuentaEspecialGNPOpciones = [
  { texto: "DACERO", valor: "DACERO" },
  { texto: "EL ORO", valor: "EL ORO" },
  { texto: "SHCP", valor: "SHCP" },
  { texto: "RENT A MATIC ITZA", valor: "RENT A MATIC ITZA" },
  { texto: "TEQUILA SAUZA", valor: "TEQUILA SAUZA" },
  { texto: "AUTOFLETES CHIHUAHUA", valor: "AUTOFLETES CHIHUAHUA" },
  { texto: "ELEMENT", valor: "ELEMENT" },
  { texto: "CONSERVAS LA COSTEÑA", valor: "CONSERVAS LA COSTEÑA" },
  { texto: "ALPURA", valor: "ALPURA" },
  { texto: "MABE", valor: "MABE" },
];

export const opcionesNoProcedente = [
  {
    value: "DE DEPENDENCIA A DEPENDENCIA",
    label: "DE DEPENDENCIA A DEPENDENCIA",
  },
  {
    value: "VEHÍCULO EN ESTACIONAMIENTO",
    label: "VEHÍCULO EN ESTACIONAMIENTO",
  },
  {
    value: "VEHÍCULO CON CARGA",
    label: "VEHÍCULO CON CARGA",
  },
  {
    value: "DE TALLER A TALLER",
    label: "DE TALLER A TALLER",
  },
  {
    value: "VEHÍCULO DESARMADO",
    label: "VEHÍCULO DESARMADO",
  },
  {
    value: "VEHÍCULO EN CORRALÓN",
    label: "VEHÍCULO EN CORRALÓN",
  },
  {
    value: "VEHÍCULO ATASCADO",
    label: "VEHÍCULO ATASCADO",
  },
  {
    value: "SIN FALLA MECÁNICA",
    label: "SIN FALLA MECÁNICA",
  },
];

export const cuentasEspecialesLabelvalue = [
  { label: "DACERO", value: "DACERO" },
  { label: "EL ORO", value: "EL ORO" },
  { label: "SHCP", value: "SHCP" },
  { label: "RENT A MATIC ITZA", value: "RENT A MATIC ITZA" },
  { label: "TEQUILA SAUZA", value: "TEQUILA SAUZA" },
  { label: "AUTOFLETES CHIHUAHUA", value: "AUTOFLETES CHIHUAHUA" },
  { label: "ELEMENT", value: "ELEMENT" },
  { label: "CONSERVAS LA COSTEÑA", value: "CONSERVAS LA COSTEÑA" },
  { label: "ALPURA", value: "ALPURA" },
  { label: "MABE", value: "MABE" },
];

export const cuentaEspecialGSPOpciones = [
  { texto: "EDO VERACRUZ", valor: "EDO VERACRUZ" },
  { texto: "PE CAMPECHE", valor: "PE CAMPECHE" },
  { texto: "MAYOREO CERAMICO", valor: "MAYOREO CERAMICO" },
  { texto: "CAPDAM", valor: "CAPDAM" },
  { texto: "VIP", valor: "VIP" },
];

export const normalizaAgenteGS = (agente = "") =>
  agente.toLowerCase().trim().replace(/\s+/g, " ");

export const agentesCuentaEspecialGS = [
  "edwin ibarra romero",
  "adr crea agente de seguros y de fianzas",
  "maria del pilar peniche larrea",
  "peniche larrea seguros y fianzas",
  "gerardo armenta sanchez",
  "evelia armenta llanes",
  "eva luz armenta perea",
  "gabriel armenta llanes",
  "ruben guillermo ballesteros armenta",
  "ignacio armenta reyes",
  "hermanos batta sa de cv",
  "mauricio miravete acevedo",
  "issac ahlai vela ruiz",
  "interproteccion,agente de seguros y de fianzas",
  "marsh mexico, agente de seguros y de fianzas",
  "marsh mexico, agente de seguros y de fia",
  "conde ramirez y asociados seguros y fianzas",
  "conde ramirez especialistas e n riesgos",
  "juan takeo kuroda arredondo",
  "jaime hernandez sanchez",
  "enrique garcia olivares",
  "armando leon ptacnik",
  "grupo gasme agente de seguros y de fianzas s.a. de c.v.",
];

export const motivoIncidenciaAsignacionOpciones = [
  {
    label: "En espera de cotización proveedor",
    value: "En espera de cotización proveedor",
  },
  { label: "En espera de fotos", value: "En espera de fotos" },
  {
    label: "Pendiente de confirmar excedente",
    value: "Pendiente de confirmar excedente",
  },
  {
    label: "Falta destino por asegurado",
    value: "Falta destino por asegurado",
  },
  { label: "Pendiente de pago directo", value: "Pendiente de pago directo" },

  { label: "Pendiente autrización", value: "Pendiente autrización" },
  {
    label: "Pendiente validación póliza",
    value: "Pendiente validación póliza",
  },
  { label: "Zona Roja", value: "Zona Roja" },
  { label: "Servicio especial", value: "Servicio especial" },
  { label: "Problemas climátios", value: "Problemas climátios" },
  { label: "Zona difícil acceso", value: "Zona difícil acceso" },
  { label: "Cierres viales", value: "Cierres viales" },
  {
    label: "Datos geolocalización incorrectos",
    value: "Datos geolocalización incorrectos",
  },
  { label: "Zona Concesionada", value: "Zona Concesionada" },
];

export const motivoIncidenciaArriboOpciones = [
  { label: "Falla en la grúa", value: "Falla en la grúa" },
  { label: "Accidente de grúa", value: "Accidente de grúa" },

  { label: "Zona Roja", value: "Zona Roja" },
  { label: "Servicio especial", value: "Servicio especial" },
  {
    label: "Usuario no encontrado en lugar",
    value: "Usuario no encontrado en lugar",
  },
  {
    label: "Datos geolocalización incorrectos",
    value: "Datos geolocalización incorrectos",
  },
  { label: "Problemas climátios", value: "Problemas climátios" },
  { label: "Plantón / marcha", value: "Plantón / marcha" },
  { label: "Calle cerrada", value: "Calle cerrada" },
  { label: "Accidente en vialidad", value: "Accidente en vialidad" },
];

export const ActividadesSeguimientoOptions = [
  { label: "Llamada", value: 1 },
  { label: "Whatsapp", value: 2 },
  {
    label: "Correo",
    value: 3,
  },
  {
    label: "SMS",
    value: 4,
  },
  { label: "Otro", value: 5 },
];

export const QuienCancelOptions = [
  { label: "Cliente", value: "Cliente" },
  { label: "Cabina Escotel", value: "Cabina Escotel" },
  { label: "Proveedor", value: "Proveedor" },
];

export const MotivosCancelacionConParentOptions = [
  {
    nombre: "Cliente",
    opciones: [
      {
        label: "No acepta excedente",
        value: "No acepta excedente",
      },
      {
        label: "Cliente no contesta",
        value: "Cliente no contesta",
      },
      {
        label: "Pendiente confirmar servicio",
        value: "Pendiente confirmar servicio",
      },
      {
        label: "Solo era informativo",
        value: "Solo era informativo",
      },
      {
        label: "Asegurado no localizado en origen",
        value: "Asegurado no localizado en origen",
      },
      {
        label: "Soluciono por sus medios",
        value: "Soluciono por sus medios",
      },
      {
        label: "Arranco el vehiculo",
        value: "Arranco el vehiculo",
      },
      {
        label: "Contrato servicio por sus medios",
        value: "Contrato servicio por sus medios",
      },
      {
        label: "No brinda datos correctos",
        value: "No brinda datos correctos",
      },
    ],
  },
  {
    nombre: "Cabina Escotel",
    opciones: [
      {
        label: "Datos erroneos para gestion",
        value: "Datos erroneos para gestion",
      },
      {
        label: "Ubicación erronea",
        value: "Ubicación erronea",
      },
      {
        label: "Es un siniestro",
        value: "Es un siniestro",
      },
      {
        label: "Servicio duplicado",
        value: "Servicio duplicado",
      },
      {
        label: "Dificil acceso para servicio de grua",
        value: "Dificil acceso para servicio de grua",
      },
      {
        label: "Servicio fuera de cobertura",
        value: "Servicio fuera de cobertura",
      },
      {
        label: "Poliza fuera de cobertura",
        value: "Poliza fuera de cobertura",
      },
      {
        label: "Pruebas",
        value: "Pruebas",
      },
    ],
  },
  {
    nombre: "Proveedor",
    opciones: [
      {
        label: "Sin proveedor en zona",
        value: "Sin proveedor en zona",
      },
      {
        label: "Costo elevado",
        value: "Costo elevado",
      },
      {
        label: "Tiempo elevado",
        value: "Tiempo elevado",
      },
      {
        label: "Zona roja",
        value: "Zona roja",
      },
      {
        label: "Falla de grua",
        value: "Falla de grua",
      },
      {
        label: "Sin disponibilidad",
        value: "Sin disponibilidad",
      },
      {
        label: "Dificil acceso para servicio de grua",
        value: "Dificil acceso para servicio de grua",
      },
      {
        label: "Retresao en servicio",
        value: "Retresao en servicio",
      },
    ],
  },
];

export const MotivosCancelacionOptions = [
  {
    label: "Difícil acceso para servicio de grúa",
    value: "Difícil acceso para servicio de grúa",
  },
  { label: "Vehículo bloqueado", value: "Vehículo bloqueado" },
  { label: "Vehículo siniestrado", value: "Vehículo siniestrado" },
  { label: "Ubicación errónea", value: "Ubicación errónea" },
  { label: "Vehículo sin falla", value: "Vehículo sin falla" },
  {
    label: "Cliente soluciona por sus medios",
    value: "Cliente soluciona por sus medios",
  },
  {
    label: "Asegurado no acepta excedente",
    value: "Asegurado no acepta excedente",
  },
  {
    label: "Asegurado no localizado en origen",
    value: "Asegurado no localizado en origen",
  },
  { label: "Sin proveedor", value: "Sin proveedor" },
  { label: "Costo elevado", value: "Costo elevado" },
  { label: "Tiempo elevado", value: "Tiempo elevado" },
  { label: "Información", value: "Información" },
  {
    label: "Pendiente confirmación de servicio",
    value: "Pendiente confirmación de servicio",
  },

  {
    label: "Asignado por HDI",
    value: "Asignado por HDI",
  },
  {
    label: "Servicio duplicado",
    value: "Servicio duplicado",
  },
  {
    label: "Cliente no responde",
    value: "Cliente no responde",
  },
  {
    label: "Sin Datos para gestión de servicio",
    value: "Sin Datos para gestión de servicio",
  },
  {
    label: "Otro",
    value: "Otro",
  },
];

export const emailsPuedeDesasignar = [
  "pat9000@hotmail.com",
  "ricardo.perez@escotel.com.mx",
  "emilio.rodriguez@escotel.com.mx",
  "beatriz.gutierrez@escotel.com.mx",
];

export const emailsPuedeDeclararQueja = [
  "ivan.villegas@escotel.com.mx",
  "sergio.bermeo@escotel.com.mx",
  "ivan.hidalgo@escotel.com.mx",
  "abraham.sanchez@escotel.com.mx",
  "daniela.gonzalez@escotel.com.mx",
  "eduardo.estrada@escotel.com.mx",
  "jacqueline.martinez@escotel.com.mx",
  "jorge.ramirez@escotel.com.mx",
  "roberto.carrillo@escotel.com.mx",
  "leslie.braga@escotel.com.mx",
  "rafael.sosa@escotel.com.mx",
  "saul.garcia@escotel.com.mx",
  "abraham.lopez@escotel.com.mx",
  "solucioneshdi@escotel.com.mx",
  "solucioneselaguila@escotel.com.mx",
  "solucionesgnp@escotel.com.mx",
  "esperanza.corona@escotel.com.mx",
  "gilberto.cordova@escotel.com.mx",
  "pat9000@hotmail.com"
];

export const requiereDestino = [1, 3, 7, 8, 34, 80, 101, 158, 159];

export const motivoIncidenciaInternaOpciones = [
  { label: "Teléfonos erróneos", value: "Teléfonos erróneos" },
  { label: "Datos erróneos de ubicación", value: "Datos erróneos de ubicación" },
  { label: "Sondeo erróneo", value: "Sondeo erróneo" },
  { label: "Validación de destino reciban la unidad", value: "Validación de destino reciban la unidad" },
  { label: "Asignación no adecuada", value: "Asignación no adecuada" },
  { label: "Datos erróneos al proveedor al asignar", value: "Datos erróneos al proveedor al asignar" },
  { label: "Validación de acceso al origen por tipo de vialidad", value: "Validación de acceso al origen por tipo de vialidad" },
  { label: "Falta de seguimiento con aseguro o proveedor", value: "Falta de seguimiento con aseguro o proveedor" },
  { label: "Sin comunicación con asegurado", value: "Sin comunicación con asegurado" },
  { label: "Falla en aplicativos internos", value: "Falla en aplicativos internos" },
  { label: "Inconsistencia en datos de aplicativos de cliente corporativos", value: "Inconsistencia en datos de aplicativos de cliente corporativos" },
  { label: "Zona Concesionada", value: "Zona Concesionada" },
  { label: "En espera de validación de datos", value: "En espera de validación de datos" },
];
